import { render } from "./PlaceholderContent.vue?vue&type=template&id=bb466ee2"
import script from "./PlaceholderContent.vue?vue&type=script&lang=js"
export * from "./PlaceholderContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__